import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = { class: "grid2 mb-5" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "secondary-font font-semibold text-5xl text-grey-900 my-2" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "secondary-font font-semibold text-5xl text-grey-900 my-2" }
const _hoisted_7 = {
  key: 0,
  class: "s20 mb-6"
}
const _hoisted_8 = {
  key: 1,
  class: "s20 flex gap-3 mb-6"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "s20" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "s13 mt-2" }
const _hoisted_13 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_14 = { class: "secondary-font font-semibold text-sm text-grey-600 mb-2" }
const _hoisted_15 = {
  key: 0,
  class: "text-grey-600 mb-4"
}
const _hoisted_16 = {
  key: 1,
  class: "pagination sm justify-content-left mt-5"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 2,
  class: "flex-center py-7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Line = _resolveComponent("Line")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-6" }, "Utilisation", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.formatAmount(_ctx.totalDecaissement)) + " F", 1),
        _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
          _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
          _createTextVNode(" Décaissement ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.formatAmount(_ctx.totalUtilisation)) + " F", 1),
        _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
          _createElementVNode("div", { class: "circle-medium bg-purple" }),
          _createTextVNode(" Utilisation ")
        ], -1))
      ])
    ]),
    (_ctx.moisList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_Line, {
            data: _ctx.lineChartData,
            options: _ctx.lineChartOptions
          }, null, 8, ["data", "options"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.moisList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moisList, (m, idx) => {
            return (_openBlock(), _createElementBlock("span", {
              key: idx,
              class: _normalizeClass(["btn sm cursor-pointer", _ctx.selectedMoisIndex === idx ? 'light2' : 'light']),
              onClick: ($event: any) => (_ctx.selectMois(idx))
            }, _toDisplayString(_ctx.moisLabel(m.mois)), 11, _hoisted_9))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTransactions, (tx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tx.id,
          class: "flex gap-6 mb-4 cursor-pointer",
          onClick: ($event: any) => (_ctx.goToTransaction(tx.id))
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "square-xl px-4 py-4",
            style: {"background-color":"rgba(0, 185, 172, 0.08)"}
          }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-trans-recharger.svg",
              width: "100%",
              class: "icon-neutral",
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h6", _hoisted_13, _toDisplayString(tx.libelle), 1),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.formatDateTransaction(tx.date)) + " - " + _toDisplayString(tx.reference), 1)
          ]),
          _createElementVNode("h5", {
            class: _normalizeClass(["s5 secondary-font text-right mt-2", tx.type === 'credit' ? 'text-green' : ''])
          }, _toDisplayString(tx.type === 'credit' ? '+' : '-') + " " + _toDisplayString(_ctx.formatAmount(tx.montant)) + " F ", 3)
        ], 8, _hoisted_11))
      }), 128)),
      (_ctx.currentTransactions.length === 0 && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Aucune transaction pour ce mois "))
        : _createCommentVNode("", true),
      (_ctx.pagination.last_page > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("button", {
              class: _normalizeClass(["page-link", { active: _ctx.pagination.current_page > 1 }]),
              disabled: _ctx.pagination.current_page <= 1,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage(_ctx.pagination.current_page - 1)))
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-pagination-prev.svg",
                class: "pagination-icon",
                alt: ""
              }, null, -1),
              _createTextVNode(" Précédent ", -1)
            ]))], 10, _hoisted_17),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagesArray, (p) => {
              return (_openBlock(), _createElementBlock("button", {
                key: p,
                class: _normalizeClass(["page-link", { active: p === _ctx.pagination.current_page }]),
                onClick: ($event: any) => (_ctx.changePage(p))
              }, _toDisplayString(p), 11, _hoisted_18))
            }), 128)),
            _createElementVNode("button", {
              class: _normalizeClass(["page-link pl-4", { active: _ctx.pagination.current_page < _ctx.pagination.last_page }]),
              disabled: _ctx.pagination.current_page >= _ctx.pagination.last_page,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage(_ctx.pagination.current_page + 1)))
            }, [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Suivant ", -1),
              _createElementVNode("img", {
                src: "/public/icons/icon-pagination-next.svg",
                class: "pagination-icon ml-2",
                alt: ""
              }, null, -1)
            ]))], 10, _hoisted_19)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("p", { class: "secondary-font text-grey-600" }, "Chargement...", -1)
        ]))]))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
  ]))
}